export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/PK-049091b5052af17a2a8d5fbbe4cb118d.png";